<div class="article-container">
    <mat-card>
      <mat-card-header>
        <mat-card-title>{{ article.title }}</mat-card-title>
        <mat-card-subtitle>
          <div class="author-info">
            <img mat-card-avatar [src]="article.authorImage" alt="Author Image">
            <div>
              <span>{{ article.author }}</span>
              <span>{{ article.publishDate | date: 'longDate' }}</span>
            </div>
          </div>
        </mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <p>{{ article.content }}</p>
      </mat-card-content>
      <mat-card-footer>
        <div class="tags">
          <mat-chip-list>
            <mat-chip *ngFor="let tag of article.tags" color="primary" selected>{{ tag }}</mat-chip>
          </mat-chip-list>
        </div>
      </mat-card-footer>
    </mat-card>
  </div>
  